module.exports = __webpack_public_path__ + "static/media/user.958b9933.svg";